var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__a",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.302 20.914a.81.81 0 0 1-.81-.81v-16.2a.81.81 0 0 1 .81-.81h1.404a.81.81 0 0 1 .81.81v16.2a.81.81 0 0 1-.81.81zm-7.398-7.398a.81.81 0 0 1-.81-.81v-1.404a.81.81 0 0 1 .81-.81h16.2a.81.81 0 0 1 .81.81v1.404a.81.81 0 0 1-.81.81z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cross_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 3H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M9 3H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 3H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M15 3h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 3h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M21 3h-3v3h3zM6 6H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 6H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 6H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 6h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M18 6h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 6h-3v3h3zM6 9H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M9 9H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 9H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M15 9h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 9h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M21 9h-3v3h3zM6 12H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 12H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 12H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 12h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M18 12h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 12h-3v3h3zM6 15H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M9 15H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 15H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M15 15h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 15h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M21 15h-3v3h3zM6 18H3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 18H6v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 18H9v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 18h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M18 18h-3v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 18h-3v3h3z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.473 20.182c0 .452.366.818.818.818h1.418a.82.82 0 0 0 .818-.818v-6.655h6.655A.82.82 0 0 0 21 12.71v-1.418a.82.82 0 0 0-.818-.818h-6.655V3.818A.82.82 0 0 0 12.71 3h-1.418a.82.82 0 0 0-.818.818v6.655H3.818A.82.82 0 0 0 3 11.29v1.418c0 .452.366.818.818.818h6.655z",
    style: {
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }));
};
export default SvgCross;